import { useRef, useState, type ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const HINT_TRIGGER_CLASS =
  'cursor-help rounded-sm underline decoration-dotted underline-offset-4 outline-none focus-visible:ring-2 focus-visible:ring-brand-link/50';

const TOUCH_POINTER_TYPE = 'touch';

interface ColumnHeaderHintProps {
  hint: string;
  children: ReactNode;
}

export function ColumnHeaderHint({ hint, children }: ColumnHeaderHintProps) {
  const [isOpen, setIsOpen] = useState(false);
  const lastPointerTypeRef = useRef('');

  function handleTriggerClick() {
    if (lastPointerTypeRef.current !== TOUCH_POINTER_TYPE) return;
    setIsOpen((wasOpen) => !wasOpen);
  }

  return (
    <Tooltip open={isOpen} onOpenChange={setIsOpen}>
      <TooltipTrigger
        render={<span />}
        tabIndex={0}
        aria-label={hint}
        closeOnClick={false}
        className={HINT_TRIGGER_CLASS}
        onPointerDown={(event) => {
          lastPointerTypeRef.current = event.pointerType;
        }}
        onClick={handleTriggerClick}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent>{hint}</TooltipContent>
    </Tooltip>
  );
}
